// extracted by mini-css-extract-plugin
var _1 = "account-w0brw";
var _2 = "active-Im6ob";
var _3 = "basket-WwUAt";
var _4 = "body-O2Dzj";
var _5 = "button-LrN48";
var _6 = "cart-FEOrX";
var _7 = "close-ngw8S";
var _8 = "count-efWkr";
var _9 = "email-woaGk";
var _a = "form-xaBrg";
var _b = "head-dcTo0";
var _c = "info-uY5bY";
var _d = "input-RpOWY";
var _e = "items-MZ7l8";
var _f = "lg-CPsbq";
var _10 = "list-qsn6S";
var _11 = "logo-LQhVW";
var _12 = "logout-GeO6o";
var _13 = "menu-LsyyK";
var _14 = "mobile-gSAkR";
var _15 = "name-Ak5LM";
var _16 = "open-acc3g";
var _17 = "price-sxWCo";
var _18 = "title-h0Ljb";
var _19 = "total-W3rHU";
var _1a = "wish-ozVbJ";
var _1b = "wrap-ZQ7PL";
export { _1 as "account", _2 as "active", _3 as "basket", _4 as "body", _5 as "button", _6 as "cart", _7 as "close", _8 as "count", _9 as "email", _a as "form", _b as "head", _c as "info", _d as "input", _e as "items", _f as "lg", _10 as "list", _11 as "logo", _12 as "logout", _13 as "menu", _14 as "mobile", _15 as "name", _16 as "open", _17 as "price", _18 as "title", _19 as "total", _1a as "wish", _1b as "wrap" }
